import { env } from "./url";
import getDeviceId from "./getDevicedId";
import getParamsFromUrl from "@/js/getParamsFromUrl";
var openApp = function(id, shareType, isnfh, cityRankInfo, clickPosition) {
  let params = getParamsFromUrl();
  let articleID = params.articleId ? params.articleId : params.nfhId;
  let options = {
    id,
    shareType,
    isnfh,
    cityRankInfo: shareType === "cityRank" ? cityRankInfo : undefined,
    needClipboard: true,
    title: document.title,
    address: window.location.href,
    openAppBigDataInfo: {
      deviceid: getDeviceId(),
      url: window.location.href,
      origin: 1,
      sourceTag: 8,
      clickPosition: clickPosition,
      itemId: articleID,
      articleID: articleID
    }
  };
  console.log("--options--", options);
  window.OpenApp(options, env);
};
export { openApp };



// WEBPACK FOOTER //
// ./src/js/openApp.js